import Head from 'next/head'

import Layout from '@/components/Layout'
import DishImg from '@/public/img/dish-programming/dish.png'
import HeaderImg from '@/public/img/dish-programming/dish-header.jpg'
import FtgImg from '@/public/img/dish-programming/ftg.jpg'
import HdImg from '@/public/img/dish-programming/hd.png'
import NvpImg from '@/public/img/dish-programming/nvp.png'

export default function DISHProgramming(): JSX.Element {
	return (
		<div className="container mx-auto max-w-screen-xl">
			<Head>
				<title key="page-title">DISH Programming | Pace International</title>
			</Head>

			<h1 className="text-4xl font-extrabold px-4 mt-4 uppercase md:mt-6 xl:text-5xl">DISH Programming</h1>
			<img className="mt-4 mx-auto md:mt-6" src={HeaderImg} alt="Header"/>

			<div className="px-4 md:px-10">
				<h2 className="text-center text-2xl italic mt-2 font-semibold md:text-3xl md:mt-4">Delight subscribers with more than they expect with DISH Programming</h2>
				<section className="mt-6 md:mt-8">
					<div className="lg:flex lg:items-center lg:justify-between">
						<div className="lg:w-7/12">
							<div className="text-center">
								<h3 className="text-xl font-extrabold">Bulk Programming Package</h3>
								<h4 className="font-semibold italic mt-1">Cost-effective programming for PCOs with a wide range of options for your customers</h4>
							</div>

							<div className="mt-4 md:mt-6">
								<p>Bulk programming is a great way to provide your residents wide variety at excellent rates. Provide your residents with basic and expanded programming without the use of in-home receivers. This program can be provided in the MDU market. Speak with our Sales team to help determine the right programming plan for your solution.</p>
								<p className="mt-4">Bulk programming allows PCOs to provide America's Top 120 channels as well as specific package extensions that cater to specific residents' interests in entertainment. All for a bulk rate!</p>
								<p className="mt-4">With the Bulk Programming Plan, you’re able to provide maximum value for residents in MDU communities. By providing programming, you can add amenity-value to your customers’ properties. This is the foundation of a scalable video solution that can later be upgraded (using the Neighborhood Value Program) as end-user wants and needs evolve.</p>
							</div>
						</div>

						<div className="lg:w-5/12 lg:ml-10">
							<img className="mx-auto" src={DishImg} alt="Dish Logo"/>
						</div>
					</div>

					<div className="mt-4 md:flex md:justify-between md:mt-6">
						<div className="md:w-1/2">
							<h3 className="text-lg font-extrabold uppercase">Features of Bulk</h3>
							<ul className="list-disc ml-5 mt-4 space-y-1.5 md:mt-5">
								<li>PCOs can earn incremental revenue</li>
								<li>An affordable way to deliver programming to every resident in your property</li>
								<li>Bulk programming can be upgraded to deliver HD programming to individual subscribers in properties (with NVP)</li>
								<li>Local channels can be added for the entire property</li>
								<li>Bills are issued to property from PCO on a monthly basis</li>
							</ul>
						</div>
						<div className="mt-5 md:mt-0 md:w-1/2 md:ml-8">
							<h3 className="text-lg font-extrabold uppercase">Technology Equipment for Bulk</h3>
							<ul className="list-disc ml-5 mt-4 space-y-1.5 md:mt-5">
								<li>Headend or SMARTBOX at the property can deliver programming to all residents (SMATV).</li>
								<li>Receivers are not required in each unit</li>
							</ul>
						</div>
					</div>
				</section>

				<hr className="mt-6 md:mt-8"/>

				<section className="mt-6 md:mt-8">
					<div className="lg:flex lg:justify-between lg:items-center">
						<div className="lg:w-5/12">
							<img className="mx-auto" src={HdImg} alt="TV"/>
						</div>
						<div className="mt-6 md:mt-8 lg:w-7/12 lg:ml-10">
							<div className="text-center">
								<h2 className="text-xl font-extrabold">Digital (HD) Programming Package</h2>
								<h4 className="font-semibold italic mt-1">Tiered programming choices enables additional revenue for PCOs</h4>
							</div>

							<div>
								<p className="mt-4">With digital programming, you can provide your residents the ability to receive the clearest and sharpest viewing experience. Residents select a package most suitable to their needs and get the full experience of digital programming. Ensure future capability for growth with the digital plan from DISH and keep your residents satisfied with their viewing experience while also generating additional revenue.</p>
								<p className="mt-4">Digital programming enables both owners and operators to earn additional revenue while providing the best viewing experience possible. Individual residents are allowed to choose their tiered programming packages and use an HD receiver in their unit. High definition, DVR, premium channels, and pay-per-view programming are all available with Digital Programming. Standard residential rates are charged to the subscriber.</p>
							</div>
						</div>
					</div>

					<div className="mt-4 md:flex md:justify-between md:mt-6">
						<div className="md:w-1/2">
							<h3 className="text-lg font-extrabold">Benefits for HD</h3>
							<ul className="list-disc ml-5 mt-4 space-y-1.5 md:mt-5">
								<li>PCO is provided a license to utilize DISH trademarks</li>
								<li>Aggressive revenue share on programming based on net revenue (excluding non-recurring charges and fees)</li>
								<li>Reimbursement for DVR and additional outlet fees available to the PCO</li>
								<li>Bundle billing is possible or PCO can manage the accounts</li>
							</ul>
						</div>
						<div className="mt-4 md:mt-0 md:ml-8 md:w-1/2">
							<h3 className="text-lg font-extrabold">Features of HD</h3>
							<ul className="list-disc ml-5 mt-4 space-y-1.5 md:mt-5">
								<li>DISH Programming</li>
								<li>DVR</li>
								<li>Pay-Per-View</li>
								<li>Local channels in HD</li>
								<li>Premium channel programming available</li>
							</ul>
						</div>
					</div>
				</section>

				<hr className="mt-6 md:mt-8"/>

				<section className="mt-6 mdLmt-9">
					<div className="lg:flex lg:flex-row-reverse lg:justify-between lg:items-center">
						<div className="lg:w-5/12 lg:ml-10">
							<img className="mx-auto" src={NvpImg} alt="Value Program"/>
						</div>

						<div className="mt-6 md:mt-8 lg:w-7/12">
							<div className="text-center">
								<h2 className="text-xl font-extrabold">Neighborhood Value Program</h2>
								<h4 className="font-semibold italic mt-1">Bulk Programming + digital upgrades for premium packages, HD, DVR, and Pay-Per-View content</h4>
							</div>

							<div className="mt-4">
								<p>The Neighborhood Value Plan (NVP) provides choices in programming at a great value. This program combines a low-cost Bulk Programming package that will be delivered to the entire property while still allowing individual residents to upgrade to their choice of premium, HD programming, DVR options and also Pay-Per-View. It delivers incredible value for the residents, the operator, and the owners with the lowest cost of entry and no limits on the entertainment experience.</p>
								<p className="mt-4">NVP is a completely scalable solution that starts with a basic Bulk Programming Package for all residents, with the option to combine digital upgrades. Once a package has been selected by the property or HOA, channels from the package are used to create a ‘Basic Property Channel Lineup,’ which residents can access without a receiver in their unit.</p>
							</div>
						</div>
					</div>


					<div className="mt-6 md:mt-8">
						<h3 className="text-xl font-extrabold">Benefits for NVP</h3>
						<ul className="list-disc ml-5 mt-4 space-y-1.5 md:mt-5">
							<li>PCOs can mark-up Bulk programming and receive commissions and activation incentives on Digital programming</li>
							<li>Begin with a BULK programming package, then add DIGITAL subscribers on an individual basis</li>
							<li>No set-top box is needed to receive the BULK programming. Digital set-top box will be added for subscribers to receive all BULK programming as well as additional programming</li>
							<li>NVP offers PCOs the ability to provide low cost Bulk programming and for residents to upgrade* their basic service</li>
							<li>*NVP requires a minimum subscription to America's Top 120 and Locals (where available)</li>
							<li>Reimbursement for DVR and additional outlet fees available to PCOs</li>
						</ul>
					</div>
				</section>

				<hr className="mt-6 md:mt-8"/>

				<div className="mt-6 md:mt-8">
					<div className="lg:flex lg:justify-between lg:items-center">
						<div className="lg:w-5/12">
							<img className="mx-auto" src={FtgImg} alt="Free To Guest"/>
						</div>

						<div className="mt-6 md:mt-8 lg:w-7/12 lg:ml-10">
							<h2 className="text-xl font-extrabold">Free To Guest</h2>
							<h4 className="font-semibold italic mt-1">Attract and entertain guests with quality programming from DISH</h4>
							<p>The Free-to-Guest (FTG) program offers quality programming to hotels, hospitals, resorts, marinas, nursing home facilities and more. FTG can be provided as a free amenity to guests. DISH provides a variety of programming packages and options including sports, latest movies, locals and international programming in addition to standard packages. FTG gives fantastic programming and delivers it to guests without the need for a receiver in each unit.</p>
						</div>
					</div>

					<div className="mt-6 mb-8 md:flex md:justify-between md:mt-8 md:mb-10 lg:mb-12">
						<div className="md:w-1/2">
							<h3 className="text-xl font-extrabold">Features of FTG</h3>
							<ul className="list-disc ml-5 mt-4 space-y-1.5 md:mt-5">
								<li>Service provided to 100% of the units passed on the property.</li>
								<li>Regional sports, Premium channels, Pay-Per-View Programming. Local channels can be added at a very low cost for the entire property.</li>
								<li> An affordable amenity to deliver to every guest &amp; PCOs are allowed to mark up and resell the programming.</li>
							</ul>
						</div>
						<div className="mt-6 md:mt-0 md:ml-8 md:w-1/2">
							<h3 className="text-xl font-extrabold">Technology Equipment for FTG</h3>
							<ul className="list-disc ml-5 mt-4 space-y-1.5 md:mt-5">
								<li>Headend or SMARTBOX at the property to deliver programming to all guests.</li>
								<li>Receivers in each room are not required.</li>
							</ul>
						</div>
					</div>
				</div>

			</div>
		</div>
	)
}

DISHProgramming.Layout = Layout
